import swal from 'sweetalert2';

export default class QuantitySelector extends HTMLElement {
    constructor() {
        super();
        this.min = 1;
        this.max = Infinity;
    }

    connectedCallback() {
        this.decreaseBtn = this.querySelector('button:first-of-type');
        this.increaseBtn = this.querySelector('button:last-of-type');
        this.input = this.querySelector('input[type="number"]');
        this.productId = this.input.dataset.productId;
        this.catalogueId = this.input.dataset.catalogueId;
        this.viewType = this.input.dataset.viewType;

        if (this.viewType === 'list') {
            this.value = parseInt(this.input.value) || this.min;
        } else {
            this.value = parseInt(this.input.value) || 0;
        }
        this.min = parseInt(this.input.min) ?? this.min;
        this.max = parseInt(this.input.max) ?? this.max;

        this.watchQuantitySelector();

        this.updateButtonStates();
    }

    boundDecrease = this.decrease.bind(this);
    boundIncrease = this.increase.bind(this);
    boundUpdateValue = this.updateValue.bind(this);

    decrease() {
        if (this.value > this.min) {
            this.value--;
            this.updateInput();
        }
    }

    increase() {
        // On récupère l'input du quantity-selector de la product card
        this.qtySelectorProductInput = document.querySelector(`.card-body quantity-selector input[data-product-id="${this.productId}"]`);

        if (this.value < this.max) {
            this.value++;
            this.updateInput();
        }
    }

    updateValue() {
        const newValue = parseInt(this.input.value);
        if (!isNaN(newValue) && newValue >= this.min && newValue <= this.max) {
            this.value = newValue;
        } else {
            this.input.value = this.value;
        }
        this.updateButtonStates();
    }

    updateInput() {
        this.input.value = this.value;
        // Si l'input du quantity-selector de la product card existe
        if (this.qtySelectorProductInput) {
            // Si l'input du quantity-selector de la product card et celui du offcanvas sont différents
            // On met à jour la valeur de l'input du quantity-selector de la product card
            const isSameInput = this.input.closest('#product-card') === this.qtySelectorProductInput.closest('#product-card');
            if (!isSameInput) {
                this.qtySelectorProductInput.value = this.value;
            }
        }
        // Si = min, on remet le bouton "Ajouter au panier"
        if (this.value === this.min && this.viewType === 'list') {
            HegydCore.sendRequest( this.input.dataset.deleteHref, 'DELETE', {
                'product_id' : this.productId,
                'catalogue_id' : this.catalogueId,
                'return_templates' : ['common.link-to-cart-icon'],
            }, (data) => {
                // On remet le bouton "Ajouter au panier"
                this.refreshTemplates(data.templates);

                const tempDiv = document.createElement('button');
                tempDiv.innerHTML = data.button;
                this.replaceWith(tempDiv.firstElementChild);
            });
        }

        this.updateButtonStates();
        this.input.dispatchEvent(new CustomEvent('change', { detail: this.value }));
    }

    updateButtonStates() {
        this.decreaseBtn.disabled = this.value <= this.min;
        this.increaseBtn.disabled = this.value >= this.max;
    }

    refreshTemplates(templates) {
        if (typeof templates === 'object') {
            for (const [name, content] of Object.entries(templates)) {
                if (typeof content !== 'string') { return; }
                const els = document.querySelectorAll(`[data-template="${name}"]`);
                for (const el of els) {
                    el.innerHTML = content;
                }
            }
        }
    }

    watchQuantitySelector() {
        this.decreaseBtn.addEventListener('click', this.boundDecrease);
        this.increaseBtn.addEventListener('click', this.boundIncrease);
        this.input.addEventListener('change', this.boundUpdateValue);
    }

    refreshQuantitySelector() {
        this.decreaseBtn.removeEventListener('click', this.boundDecrease);
        this.increaseBtn.removeEventListener('click', this.boundIncrease);
        this.input.removeEventListener('change', this.boundUpdateValue);

        this.watchQuantitySelector();
    }

    setMax(max) {
        this.input.max = max;
        this.max = max;

        this.refreshQuantitySelector();
        this.updateValue();
    }
}
